/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_result_distribution = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How often each type of result occurred this season`)
};

const es_f1_profile_tooltip_result_distribution = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frecuencia de cada tipo de resultado esta temporada`)
};

const de_f1_profile_tooltip_result_distribution = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häufigkeit jedes Ergebnistyps in dieser Saison`)
};

const nl_f1_profile_tooltip_result_distribution = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe vaak elk type resultaat voorkwam dit seizoen`)
};

const fr_f1_profile_tooltip_result_distribution = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence de chaque type de résultat cette saison`)
};

const it_f1_profile_tooltip_result_distribution = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza di ogni tipo di risultato in questa stagione`)
};

const pt_br2_f1_profile_tooltip_result_distribution = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequência de cada tipo de resultado nesta temporada`)
};

const pt_f1_profile_tooltip_result_distribution = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequência de cada tipo de resultado nesta época`)
};

const ja_f1_profile_tooltip_result_distribution = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今シーズンの各結果タイプの頻度`)
};

const zh_f1_profile_tooltip_result_distribution = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本赛季各类结果出现的频率`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_result_distribution = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_result_distribution(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_result_distribution", locale)
	if (locale === "en") return en_f1_profile_tooltip_result_distribution(inputs)
	if (locale === "es") return es_f1_profile_tooltip_result_distribution(inputs)
	if (locale === "de") return de_f1_profile_tooltip_result_distribution(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_result_distribution(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_result_distribution(inputs)
	if (locale === "it") return it_f1_profile_tooltip_result_distribution(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_result_distribution(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_result_distribution(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_result_distribution(inputs)
	return zh_f1_profile_tooltip_result_distribution(inputs)
};